export default __webpack_public_path__ + "static/media/utb-symbol.b59d8048.svg";